const PhoneCountryData = {
    US: {
        name: 'United States',
        code: 'US',
        phonePrefix: '+1',
        regex: /^((\+|)1)*(( )*|-?)(?![0-9]{3}\))(\((?=[0-9]{3}\)))*[0-9]{3}\)*( |-)?[0-9]{3}( |-)?[0-9]{4}\b/
        // example:
        // +1 (222) 123 2345
        // +1 234 234 3333 //boolean
        // 1 555-555-5555 //true
        // 1 (555) 555-5555 //true
        // 5555555555 //true
        // 555-555-5555 //true
        // (555)555-5555 //true
        // 1(555)555-5555
        // +1-925-237-9209
        // +1-(925)-237-9209
        // + 1 - (925)237-9209
        // + 1 - 925 - 237 - 9209
        // + 19252379209
        // + 1 - 9252379209
    },
    GB: {
        name: 'United Kingdom',
        code: 'UK',
        phonePrefix: '+44',
        regex: /^((((\+44\s?([0–6]|[8–9])\d{3} | \(?0([0–6]|[8–9])\d{3}\)?)\s?\d{3}\s?(\d{2}|\d{3}))|((\+44\s?([0–6]|[8–9])\d{3}|\(?0([0–6]|[8–9])\d{3}\)?)\s?\d{3}\s?(\d{4}|\d{3}))|((\+44\s?([0–6]|[8–9])\d{1}|\(?0([0–6]|[8–9])\d{1}\)?)\s?\d{4}\s?(\d{4}|\d{3}))|((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4})))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/
        // Example
        // 03069990695
        // 3069990695
        // +443069990695
        // 00443069990695
        // 09098790941
        // +449098790941
        // 07700900348
        // +447700900348
        // 08081570122
    },
    AU: {
        name: 'Australia',
        code: 'AU',
        phonePrefix: '+61',
        regex: /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/
        // example: 0434555444
        // 0433 444 444
        // 043 3444 444
        // +61 0444 444 444
        // +61 (0)444 444 444
        // +61(0) 401 735 555
        // +61 (0) 401 444 444
    },
    CA: {
        name: 'Canada',
        code: 'CA',
        phonePrefix: '+1',
        regex: /^((\+|)1)*( )*(?![0-9]{3}\))(\((?=[0-9]{3}\)))*[0-9]{3}\)*( |-)?[0-9]{3}( |-)?[0-9]{4}\b/
        // example:
        // +1 (222) 123 2345
        // +1 234 234 3333
        // 1 555-555-5555
        // 1 (555) 555-5555
        // 5555555555
        // 555-555-5555
        // (555)555-5555
        // 1(555)555-5555
    },
    NZ: {
        name: 'New Zealand',
        code: 'NZ',
        phonePrefix: '+64',
        regex: /^((\+|)64)*(( )*|-?)(?![0-9]{2}\))(\((?=[0-9]{2}\)))*[0-9]{2}\)*( |-)?[0-9]{3}( |-)?\d{0,4}\b/
        // example:
        // +6433863447
        // +64278690028
        // +64027869002
        // +64 21 123 456
        // +64-21-123-456
        // +64(21) 123 456
        // +64(21)-123-456
        // +64(21)-121 1456
        // +64(21)-121 456
    },
    OTHER: {
        name: 'OTHER',
        code: '',
        phonePrefix: '',
        regex: [
            {
                regex: /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g,
                minLimit: 10
            },
            {
                regex: /^((\+61\s?)?(\((0|02|03|04|07|08)\))?)?\s?\d{1,4}\s?\d{1,4}\s?\d{0,4}$/g,
                minLimit: 8
            }
        ]
    }
};

export default PhoneCountryData;
